import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import {State} from "../../ducks"
import {REALM_HEADER} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const {
        textAlignment,
        text: {
            chevron: {chevronIconAltText},
        },
        request: {siteUrl},
        settings: {variant, iconsVersionPath},
    } = state
    const realm = (state.request.headers as IncomingHttpHeaders)[REALM_HEADER] as string

    return {
        textAlignment,
        chevronIconAltText,
        siteUrl,
        realm,
        variant,
        iconsVersionPath,
        templating: state.template,
    }
}

export default connect(mapStateToProps)
